import React from 'react';

import Sidebar from '../../components/Navigation/Sidebar';
import Topbar from '../../components/Navigation/Topbar';
import PropTypes from "prop-types";

export default function Layout({ children }) {
    return (
        <div style={{ overflowX: 'hidden', maxWidth: '100%', backgroundColor: '#0a0e27' }}>
            <div id="wrapper" style={{ maxWidth: '100%', overflowX: 'hidden', backgroundColor: '#0a0e27' }}>
                <Sidebar />
                <div
                    id="content-wrapper"
                    className="d-flex flex-column flex-grow-1"
                    style={{
                        minHeight: '100vh',
                        flex: '1 1 0%',
                        minWidth: 0,
                        maxWidth: '100%',
                        overflowX: 'hidden',
                        backgroundColor: '#0a0e27',
                    }}
                >
                    <div
                        id="content"
                        className="d-flex flex-column flex-grow-1 w-100"
                        style={{ minWidth: 0, maxWidth: '100%' }}
                    >
                        <Topbar/>
                        <div
                            className="container-fluid d-flex flex-column flex-grow-1"
                            style={{ minHeight: 0, minWidth: 0, maxWidth: '100%', width: '100%' }}
                        >
                            { children }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

Layout.propTypes = {
    children: PropTypes.element.isRequired,
};